
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { namespace } from "vuex-class";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
// interfaces
import { courseElementTypeItems } from "@/interfaces/Types";
import { ExerciseVM, ExScormSettingsVm } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { ExBundle } from "@/interfaces/UnsubscribedTopic";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";
import { ParamDictionary } from "@/interfaces/ParamDictionary";

const globals = namespace("globals");

@Component({
  components: {
    ExpandableCard,
  },
})
export default class ScormElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;
  @globals.Getter selectedBundle!: ExBundleVM | null;
  @globals.Getter selectedExercise!: ExerciseVM | null;
  @globals.Getter selectedElement!: CourseElementVm | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;
  openingMode: string = 'OpenInIframe'; // Default value, can be changed based on requirements

  async mounted() {
  }

    async onSave() {
    await rest.url("contentManager/addOrUpdateExercise")
      .post(this.selectedExercise)
      .then((response) => {
        // if (!response) return;
        // this.$emit("saved:editModuleDlg");
      })
      .finally(() => {
        // this.busyOnSave = false;
      });
  }


  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
